export default "__VITE_ASSET__C3x2JzTa__"